import MoreVertIcon from '@mui/icons-material/MoreVert'
import { IconButton, Link, Menu, MenuItem } from '@mui/material'
import { FlexCol, FlexRow, LinkEx } from '@xylabs/sdk-react'
import { useContext, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { AppSettingsContext, AuthenticationContext } from '../../Contexts'

export interface HeaderMenuItem {
  admin?: boolean
  dev?: boolean
  label: string
  onClick?: () => void
  to?: string
}

interface HeaderMenuProps {
  items?: HeaderMenuItem[]
}

const XyoMenu: React.FC<HeaderMenuProps> = (props) => {
  const { developerMode } = useContext(AppSettingsContext)
  const { authEntity } = useContext(AuthenticationContext)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const { items = [] } = props

  const isAdmin = authEntity?.admin

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  return (
    <div>
      <IconButton aria-controls="header-menu" aria-haspopup="true" onClick={handleClick} style={{ padding: '6px' }}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} id="simple-menu" keepMounted onClose={handleClose} open={Boolean(anchorEl)}>
        {items.map((item, index) => {
          const show = (item.dev !== true || developerMode) && (item.admin !== true || isAdmin)
          if (!show) {
            return null
          }
          if (item.onClick) {
            return (
              <MenuItem key={index}>
                <Link
                  onClick={() => {
                    handleClose()
                    item.onClick?.()
                  }}
                >
                  {item.label}
                </Link>
              </MenuItem>
            )
          } else if (item.to) {
            return (
              <MenuItem key={index}>
                <LinkEx
                  to={item.to}
                  onClick={() => {
                    handleClose()
                    item.onClick?.()
                  }}
                >
                  {item.label}
                </LinkEx>
              </MenuItem>
            )
          } else {
            throw Error('Menu Item requires either a [to] or [onClick] property')
          }
        })}
      </Menu>
    </div>
  )
}

const HeaderMenu: React.FC<HeaderMenuProps> = (props) => {
  const { auth, signIn, signOut } = useContext(AuthenticationContext)
  const { items } = props
  const { pathname } = useLocation()

  const defaultMenuItems: HeaderMenuItem[] = [
    { label: 'Auctions', to: '/auctions' },
    { label: 'Map', to: '/play' },
    { label: 'Geotokens', to: '/geotoken/fhr' },
    { label: 'Contracts', to: '/contracts' },
    { label: 'Rules', to: '/rules' },
    { label: 'Holdings', to: '/entity' },
    { label: 'Settings', to: '/settings' },
    {
      label: auth?.authenticated() ? 'Sign Out' : 'Sign In',
      onClick: async () => {
        if (auth?.authenticated()) {
          signOut?.()
        } else {
          await signIn?.()
        }
      },
    },
    { admin: true, label: 'Entities', to: '/entities' },
    { admin: true, label: 'Verify', to: '/geotokens/settings' },
    { dev: true, label: 'Play', to: '/play' },
    { dev: true, label: 'Json', to: `${pathname}/json` },
  ]

  return (
    <FlexRow>
      <FlexRow sx={{ display: { md: 'inherit', xs: 'none' } }}>
        <XyoMenu items={(items ?? []).concat(defaultMenuItems)} />
      </FlexRow>
      <FlexCol sx={{ display: { md: 'none' } }}>
        <XyoMenu items={(items ?? []).concat(defaultMenuItems)} />
      </FlexCol>
    </FlexRow>
  )
}

export default HeaderMenu
